const colors = {
  brand: {
    primary: '#0094FF',
    secondary: '#898989',
    black: '#121212',
    white: '#F5F2EB'
  },
  neutral: {
    // 100: '#E2E2E2',
    200: '#C1B9A9',
    300: '#969696',
    400: '#5E5E5E',
    // 500: '#494949',
    700: '#202020'
    // 800: '#1A1A1A',
    // 1000: '#131313'
  },
  white: '#FFF',

  black: '#121212',
  orange: '#FF4500',
  sand: '#fdd7af',
  success: '#2E9F30',
  error: '#FF4500',
  primaryWhite: '#EBEBEB',
  warning: {
    100: '#eed202'
  },
  boost: '#00ffff',
  nitro: '#7DF9FF',

  meme: '#E59905',

  cyan: {
    1: '#1A9D9D'
  },

  green: {
    1: '#2E9F30',
    2: '#589608'
  },

  purple: {
    1: '#FF00F5'
  },

  secondary: {
    darkOrange: '#330E00'
  },

  bg: {
    accent: '#C93B07'
  },

  txt: {
    accent: '#FFAD8F'
  },

  gray: {
    1: '#131313',
    2: '#1A1A1A',
    3: '#101010',
    4: '#888888',
    5: '#1E1E1E',
    6: '#202020',
    7: '#242424',
    8: '#1C1C1C',
    9: '#171717',
    10: '#222222',
    11: '#313131',
    12: '#2e2e2e',
    13: '#191919',
    14: '#909090',
    15: '#6F6F6F',
    16: '#1B1B1B',
    17: '#898989'
  },

  danger: {
    200: '#F0C2BF',
    800: '#6D2723'
  },

  blackOpacity: {
    96: 'rgba(18, 18, 18, 0.96)'
  },

  whiteOpacity: {
    4: 'rgba(255, 255, 255, 0.04)',
    6: 'rgba(255, 255, 255, 0.06)',
    10: 'rgba(255, 255, 255, 0.1)',
    12: 'rgba(255, 255, 255, 0.12)',
    50: 'rgba(255, 255, 255, 0.5)',
    70: 'rgba(255, 255, 255, 0.7)'
  },

  badges: {
    points: '#FFAC0A',
    boosted: '#B6FF1A',
    events: '#FEDA9B'
  }
};

export default colors;
